import { Pipe, PipeTransform } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';
import { CalendarEventTitle as CalendarEventTitleService } from './../providers/calendarEventTitle.provider';


export class CalendarEventTitle implements PipeTransform {

  constructor(private calendarEventTitle: CalendarEventTitleService) {}

  transform(event: CalendarEvent, titleType: string): string {
    return this.calendarEventTitle[titleType](event);
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'calendarEventTitle'
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: CalendarEventTitleService, },
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
